import { render, staticRenderFns } from "./iconTudaSuda.vue?vue&type=template&id=121df8f2&scoped=true&lang=pug"
import script from "./iconTudaSuda.vue?vue&type=script&lang=js"
export * from "./iconTudaSuda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121df8f2",
  null
  
)

export default component.exports